import { apiClient } from '@api'

class OrganizationDocumentService {
	async getAll() {
		return apiClient.get('/organization-documents')
	}

	async create(title, driveLink) {
		return apiClient.post('/organization-documents', { title, drive_link: driveLink })
	}

	async update(id, title, driveLink) {
		return apiClient.put(`/organization-documents/${id}`, { title, drive_link: driveLink })
	}

	async delete(id) {
		return apiClient.delete(`/organization-documents/${id}`)
	}
}

export const organizationDocumentService = new OrganizationDocumentService()
export default organizationDocumentService
